import styled from 'styled-components';

export const LayoutContainer = styled.section`
    display: flex;
    gap: 24px;
    flex-direction: column;
    && :has(.mantine-Table-root) {
        outline: none !important;
    };
`;

export const WidgetTitle = styled.p`
    font-size: 16px;
    font-weight: 700;
`;

export const WidgetSubtitle = styled.span`
    font-size: 14px;
    color: #8C8C8C;
    font-weight: 600;
`;

export const WidgetStatistic = styled.span`
    margin-right: 4px;
    margin-left: 4px;
    font-size: 14px;
    color: #8C8C8C;
    font-weight: 600;
    padding: 2px 4px;
    border: 1px solid #8C8C8C;
    border-radius: 4px;
`;

export const WidgetContainer = styled.div`
    border-radius: 6px;
    padding: 16px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
    background-color: #FFF;
    overflow: hidden;
`;

export const CardContainer = styled(WidgetContainer)`
    display: flex;
    align-items: center;
    flex: 1 1 260px;
    height: 100px;
`;

export const TopSmallWidgetContainer = styled(WidgetContainer)`
    flex: 1 1 240px;
    height: 360px;
`;

export const TopBigWidgetContainer = styled(WidgetContainer)`
    padding-bottom: 4px;
    flex: 3 1 260px;
    height: 360px;
`;

export const BottomSmallWidgetContainer = styled(WidgetContainer)`
    flex: 1 1 240px;
    height: 500px;
`;

export const BottomBigWidgetContainer = styled(WidgetContainer)`
    flex: 4 1 260px;
    height: 500px;
`;